// Keep track of all loaded plugins. Useful for loading a plugin independent of
// the menu system. 
import { getUrlParam } from "@/Core/UrlParams";
// the menu system.
export const loadedPlugins = {};
export let allMenuData = [];
/**
 * Set the menu data.
 *
 * @param  {IMenuEntry[]} menuData  The menu data.
 */
export function setAllMenuData(menuData) {
    allMenuData = menuData;
}
/**
 * Register a plugin as loaded.
 *
 * @param  {PluginParentClass} plugin  The plugin to register.
 */
export function registerLoadedPlugin(plugin) {
    // Throw an error if the plugin already registered.
    if (loadedPlugins[plugin.pluginId]) {
        throw new Error(`Plugin with id ${plugin.pluginId} already registered.`);
    }
    loadedPlugins[plugin.pluginId] = plugin;
}
// Test-only: expose the registry on window when ?test= is present, so the
// screenshot/docs-capture infrastructure can read plugin metadata.  Gated on
// the URL parameter so production sessions never see this.
if (typeof window !== "undefined" && getUrlParam("test")) {
    window.__molmodaLoadedPlugins = loadedPlugins;
}
